import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardToolbarService {
  readonly searchQuery$ = new BehaviorSubject<string>('');
  readonly newJobRequested$ = new Subject<void>();

  setSearchQuery(query: string): void {
    this.searchQuery$.next(query);
  }

  requestNewJob(): void {
    this.newJobRequested$.next();
  }
}
